// apps/client/src/game/testFinders/digging.ts (M2-T09) — `__wt.find('digSpot')`: your dig spot nearest `near` (its tile centre).
import { useGame } from '../../state/store';
import type { TestFinder } from '../testHooks';

export const finders: readonly TestFinder[] = [{
  kind: 'digSpot',
  find(_game, near) {
    const spots = useGame.getState().you?.yields.digSpots ?? [];
    const ranked = [...spots].sort((a, b) => near ? Math.hypot(a.x - near.x, a.y - near.y) - Math.hypot(b.x - near.x, b.y - near.y) : 0);
    const s = ranked[0];
    return s ? { id: s.id, x: s.x + 0.5, y: s.y + 0.5 } : null;
  },
}];
